<template>
    <div class="flex items-center my-6 mt-8 content-start">
        <h1 class="text-white font-bold text-3xl flex-no-shrink">
            <slot></slot>
        </h1>
    </div>
</template>

<script>
export default {
    name: "Header",
}
</script>

<style scoped>
@media (max-width: 480px) {
    h1 {
        font-size: 1.5em !important;
        word-break: break-word !important;
    }
}
</style>
